import { componentModifiers } from 'craft/constants';
import { useEditor } from 'craft/hooks/useEditor';

export const useNodeWithModifiers = () => {
  const { query } = useEditor();

  const nodesHaveDifferentModifierState = (
    firstNodeId: string,
    nextNodeId: string,
  ): string | undefined => {
    const nextNode = query.node(nextNodeId).get();

    const nextModifierId = componentModifiers[nextNode.data?.name]
      ? nextNodeId
      : query
          .node(nextNodeId)
          .ancestors(true)
          .find((ancestorNodeId: string) => {
            const { data } = query.node(ancestorNodeId).get();
            return componentModifiers[data?.name];
          });

    if (!nextModifierId) {
      return undefined;
    }
    const nextNodeModifier = query.node(nextModifierId).get();
    const nextDataType = nextNodeModifier.data.name;
    const stateModifier = componentModifiers[nextNodeModifier.data.name];

    if (!stateModifier?.length) {
      return undefined;
    }

    // either the firstNode matches the nextNode data type, etiher we shall look at its ancestors
    const firstNode = query.node(firstNodeId).get();
    const firstNodeCommonTypeId =
      firstNode.data.name === nextDataType
        ? firstNodeId
        : query
            .node(firstNodeId)
            .ancestors(true)
            .find((ancestorNodeId: string) => {
              const { data } = query.node(ancestorNodeId).get();
              const ancestorDataType = data?.name;
              return ancestorDataType === nextDataType;
            });

    if (!firstNodeCommonTypeId) {
      return undefined;
    }

    const sharedAncestor = query.node(firstNodeCommonTypeId).get();
    const isSwitchingToADifferentState =
      stateModifier.findIndex((modifier) => {
        return (
          sharedAncestor.data.props[modifier] &&
          sharedAncestor.data.props[modifier] !== nextNodeModifier.data.props[modifier]
        );
      }) > -1;

    return isSwitchingToADifferentState ? sharedAncestor.data.parent : undefined;
  };
  return {
    nodesHaveDifferentModifierState,
  };
};
